/**
 * Referrals Page
 * User-facing referral program where users can invite friends and track rewards
 */

import { ReferralProgram } from '../components/ReferralProgram';

export default function Referrals() {
  return (
    <div className="min-h-screen bg-neutral-900 p-4 md:p-8">
      <div className="max-w-5xl mx-auto">
        <ReferralProgram />
      </div>
    </div>
  );
}
